import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import useFetchAemBrspdContents from "../../../../../shared/hooks/useFetchAemBrspdContents";
import { errorConditionGTM } from "../../../Utils/googleTags";
import ApiUrls from "../../../Utils/axr";

type helpSupportContentDetailsInitialStateType = {
  helpSupportPageContent: any;
  loading: boolean;
  error: any;
};
const initialState: helpSupportContentDetailsInitialStateType = {
  helpSupportPageContent: null,
  loading: false,
  error: null,
};

const host = window?.location?.host;
const file = "help-and-support-content.json";

export const getHelpSupportPageContent = createAsyncThunk(
  "get/helpSupport-page/content",
  async () => {
    try {
      const response = await useFetchAemBrspdContents({
        [ApiUrls.aem_content]: `${file}?appName=${host}`,
      });
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

const helpSupportContentDetailSlice = createSlice({
  name: "helpSupport-page/Details",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getHelpSupportPageContent.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getHelpSupportPageContent.fulfilled, (state, action) => {
      state.helpSupportPageContent = action.payload;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(getHelpSupportPageContent.rejected, (state, action) => {
      errorConditionGTM(
        "BRSPD_Fiber_EC_Flow",
        "Help and support content",
        action.error?.message,
        action?.type
      );
      state.helpSupportPageContent = null;
      state.loading = false;
      state.error = action.error;
    });
  },
});

export default helpSupportContentDetailSlice.reducer;
